/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions, jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

import Header from '@/layouts/navbar';
// import NewFaq from '@/pages/home/FAQ/NewFaq.jsx';
import NewFaq2 from '@/pages/home/FAQ/NewFaq2.jsx';

import Footer from '@/layouts/footer';
import { useLocales } from '@/locales';
import utilityApi from '@/api/utilityApi';
import { useApiQuery } from '@/hooks/useApi';
import LeaveRequest from '@/pages/home/sections/leave-request/LeaveRequest';
import { useErrorDialogDispatch } from '@/stores/errorDialogStore';
import { ChevronRight, Newspaper, Share2 as ShareIcon } from 'lucide-react';

export default function Home({ elementRefs, scrollToElement }) {
  const navigate = useNavigate();
  const [active, setActive] = React.useState('');
  const errorDispatch = useErrorDialogDispatch();

  // Share buttonni bosilganda Link Copied degan yozuvning ko'rinishi
  const [shareLinkCopied1, setShareLinkCopied1] = useState(false);
  // const [shareLinkCopied2, setShareLinkCopied2] = useState(false);
  // const [shareLinkCopied3, setShareLinkCopied3] = useState(false);
  // const [shareLinkCopied4, setShareLinkCopied4] = useState(false);

  // const elementRefs = {
  //   newsRef: useRef(null),
  //   aboutUsRef: useRef(null),
  //   contactsRef: useRef(null),
  //   partnersRef: useRef(null),
  //   faqRef: useRef(null),
  //   mapRef: useRef(null),
  // };

  // const scrollToElement = elementRef => {
  //   elementRef.current.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //     alignToTop: true,
  //   });
  // };
  const { currentLang, translate } = useLocales();

  const suppressNewsErrors =
    import.meta.env.VITE_SUPPRESS_NEWS_ERRORS === 'true' || import.meta.env.DEV;
  const disableNewsFetch = import.meta.env.VITE_DISABLE_NEWS_FETCH === 'true';

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  // Use the new API layer with React Query
  const {
    data: newsData,
    isLoading: newsLoading,
    error: newsError,
  } = useApiQuery(
    ['home-news'],
    () => utilityApi.getNews({ page: 1, limit: 10 }),
    {
      enabled: !disableNewsFetch,
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: suppressNewsErrors ? false : 3,
      onError: error => {
        console.error('News API error:', error);
        if (!suppressNewsErrors) {
          errorDispatch({
            type: 'OPEN_ERROR_DIALOG',
            errorMsg: translate('systemError'),
          });
        }
      },
    },
  );

  const handleActive = data => {
    setActive(data);
  };

  const shareLinkCopy = e => {
    e.stopPropagation();
    navigator.clipboard.writeText(window.location.href);

    setShareLinkCopied1(true);
    setTimeout(() => {
      setShareLinkCopied1(false);
    }, 2000);
  };

  return (
    <div className="home">
      <Header
        active={active}
        handleActive={data => handleActive(data)}
        scrollToElement={scrollToElement}
        elementRefs={elementRefs}
      />
      <main className="home__section">
        <div className="home__section--intro">
          <div className="section__intro">
            <h3>
              Exim<span>ERP</span>
            </h3>
            <p>{translate('bring')}</p>
            <div className="section__intro--details">
              <Button
                variant="default"
                onClick={() => {
                  scrollToElement(elementRefs.faqRef);
                  handleActive('faq');
                }}
              >
                {translate('Question')}
              </Button>
              <Button
                variant="outline"
                className="outline"
                onClick={() => {
                  scrollToElement(elementRefs.contactsRef);
                  handleActive('contacts');
                }}
              >
                {translate('Connect_us')}
              </Button>
            </div>
          </div>

          <div className="home__section--main-right">
            <div className="home__section--main-right--laptop"></div>
            <div className="home__section--main-right--rectengel"></div>
          </div>
        </div>

        <div ref={elementRefs.aboutUsRef} className="home__section--about">
          <div className="about">
            <div className="about__picture">
              <div className="about__picture--top"></div>
              <div className="about__picture--bottom"></div>
              <div className="about__picture--above">
                <div className="about__picture--abovetop"></div>
                <div className="about__picture--above-logo"></div>
              </div>
            </div>
            <div className="about__desc">
              <h3>{translate('About_us')}</h3>
              <h4>{translate('About_us_main')}</h4>
              <ul>
                <li>{translate('About_use_one')}</li>
                <li>{translate('About_us_two')}</li>
                <li>{translate('About_us_three')}</li>
                {/* <li>{translate('About_us_four')}</li> */}
              </ul>
              <Button
                className="app-button-blue margin-top-1 about__btn"
                onClick={() => navigate('/about')}
              >
                {translate('more')}
              </Button>
            </div>
          </div>
        </div>

        {/* partners */}
        <div ref={elementRefs.partnersRef} className="home__section--partners">
          <h3>{translate('Partners')}</h3>

          <div className="partners">
            <a
              href={'https://asycuda.org/en/'}
              target={'_blank'}
              rel="noreferrer"
              className="partners__link"
            >
              <div className="partners--logo one" />
            </a>

            <a
              href={'https://www.cbp.gov/'}
              className="partners__link"
              target={'_blank'}
              rel="noreferrer"
            >
              <div className="partners--logo two" />
            </a>

            <a
              className="partners__link partners__link--three"
              href={'https://www.unipass.or.kr/about-us/'}
              target={'_blank'}
              rel="noreferrer"
            >
              <div className="partners--logo three" />
            </a>
          </div>
        </div>

        {/* leave-request section */}
        <div ref={elementRefs.contactsRef}>
          <LeaveRequest />
        </div>

        {/* /leave-request section */}
        {/* Faq section */}
        <div ref={elementRefs.faqRef}>
          {/* <NewFaq /> */}

          <NewFaq2 />
        </div>
        {/* /Faq section */}
        {/* News section */}
        <div ref={elementRefs.newsRef}>
          <div className="home__section--sharing-news">
            <div className="sharing-new">
              <div ref={elementRefs.newsRef} className="sharing-new__header">
                <h3>{translate('Recent_news')}</h3>
                <h5 onClick={() => navigate('/news')}>
                  {translate('All_news')}
                  <ChevronRight className="h-4 w-4" />
                </h5>
              </div>
              <div className="sharing-new__contents">
                {(() => {
                  const newsList =
                    newsData && Array.isArray(newsData)
                      ? newsData
                      : newsData?.data || [];

                  if (newsLoading) {
                    return (
                      <div className="sharing-new__placeholder">
                        <p>{translate('loading')}</p>
                      </div>
                    );
                  }

                  if (newsError || newsList.length === 0) {
                    return (
                      <div className="sharing-new__placeholder">
                        <Newspaper className="sharing-new__placeholder-icon" />
                        <h4>{translate('news_empty_title')}</h4>
                        <p>{translate('news_empty_subtitle')}</p>
                      </div>
                    );
                  }

                  return newsList.slice(0, 4).map(item => {
                    return (
                      <div
                        key={item._id}
                        className="sharing-new__content"
                        onClick={() => navigate('/news/' + item._id)}
                      >
                        <div className="content-box__image four">
                          <img src={item?.photo?.url} alt="news picture" />
                        </div>
                        <div className="content-box__form">
                          <h4>{item.header[`${currentLang.value}`]}</h4>
                          <p>{item.text[`${currentLang.value}`]}</p>
                          <div className="sharing-new__content--details">
                            <p className="subtitle text-disabled">
                              {item.createdAt.slice(0, 10)}
                              <span>{item.createdAt.slice(11, 16)}</span>
                            </p>
                            <div className="sharing-details">
                              <Button
                                variant="ghost"
                                size="icon"
                                className="light"
                                onClick={shareLinkCopy}
                              >
                                <ShareIcon />
                              </Button>
                              <div
                                className="share-next-icon"
                                onClick={() => navigate('/news/' + item.id)}
                              >
                                <div className="share-next-icon">
                                  <Button variant="ghost" size="icon">
                                    <ChevronRight className="h-4 w-4" />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  });
                })()}
                {shareLinkCopied1 && (
                  <p className="linkCopied-home">Link Copied!</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* responsive started */}

        {/* responsive finished */}

        {/* /News section */}
        {/* Footer section */}
        <Footer
          active={active}
          handleActive={data => handleActive(data)}
          scrollToElement={scrollToElement}
          elementRefs={elementRefs}
        />
        {/* /Footer section */}
      </main>
    </div>
  );
}
